function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { chain } from 'lodash';
export var TiposDocStore = /*#__PURE__*/function () {
  function TiposDocStore(tiposDocList) {
    var _this = this;
    _classCallCheck(this, TiposDocStore);
    this.tiposDocList = tiposDocList;
    this.gruposList = this.listaTiposDoc(tiposDocList);
    this.tiposDocMap = {};
    chain(this.gruposList).flatMap(function (g) {
      return g.list;
    }).forEach(function (t) {
      return _this.tiposDocMap[t.tipo] = t;
    }).value();
  }
  return _createClass(TiposDocStore, [{
    key: "gruposDocList",
    value: function gruposDocList() {
      return this.gruposList;
    }
  }, {
    key: "listaTiposDoc",
    value: function listaTiposDoc(tipos) {
      return tipos.grupos.map(function (g) {
        return {
          label: g.label,
          list: g.tipos.map(function (t) {
            var _t = t;
            if (t.required) _t.icon = '/candidato/images/success3.png';
            if (t.notas) {
              _t.html = "<span>".concat(t.texto_en, "</span><br/><em>").concat(t.notas, "</em>");
            }
            return _t;
          })
        };
      });
    }
  }]);
}();
export var TiposDocEstadosStore = /*#__PURE__*/function (_TiposDocStore) {
  function TiposDocEstadosStore(tipos) {
    var _this2;
    _classCallCheck(this, TiposDocEstadosStore);
    _this2 = _callSuper(this, TiposDocEstadosStore, [tipos.tipos]);
    _this2.tipos = tipos;
    return _this2;
  }
  _inherits(TiposDocEstadosStore, _TiposDocStore);
  return _createClass(TiposDocEstadosStore, [{
    key: "estadosStore",
    value: function estadosStore() {
      return this.tipos.estados;
    }
  }]);
}(TiposDocStore);